// Public-side fetch for the proposals feed. The endpoint already
// filters to is_published=true, so anything we render here has been
// editor-approved.
//
// Returns the raw rows (sorted by display_order then party/topic at the
// SQL level); the consumer component groups / filters as it likes.

import useSWR from 'swr';
import type { ProposalRow } from '../db/types';

interface ApiResponse {
  proposals: ProposalRow[];
  fetchedAt: string;
}

const fetcher = async (url: string): Promise<ApiResponse> => {
  const res = await fetch(url, { credentials: 'include' });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return (await res.json()) as ApiResponse;
};

export function useProposals(): {
  proposals: ProposalRow[];
  isLoading: boolean;
  error: Error | null;
} {
  const { data, error, isLoading } = useSWR<ApiResponse>('/api/proposals', fetcher, {
    revalidateOnFocus: true,
    dedupingInterval: 30_000,
    errorRetryCount: 2,
  });
  return {
    proposals: data?.proposals ?? [],
    isLoading,
    error: error ?? null,
  };
}
